import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// B2C 페이지 타이틀 매핑
const PAGE_TITLES: Record<string, string> = {
  '/': '홈',
  '/landing': '랜딩',
  '/learn': '학습',
  '/products': '상품 목록',
  '/subscription/plans': '구독 플랜',
  '/subscription/success': '구독 완료',
  '/profile': '프로필',
  '/login': '로그인',
  '/register': '회원가입',
  '/admin': '관리자 대시보드',
  '/admin/users': '회원 관리',
  '/admin/subscriptions': '구독 관리',
  '/admin/products': '상품 관리',
  '/admin/contents': '콘텐츠 관리',
}

// 동적 라우트 패턴
const DYNAMIC_PATTERNS: Array<{ pattern: RegExp; title: string }> = [
  { pattern: /^\/products\/\d+$/, title: '상품 상세' },
  { pattern: /^\/checkout\/\d+$/, title: '결제' },
  { pattern: /^\/learn\/curriculum\/\d+$/, title: '커리큘럼' },
  { pattern: /^\/learn\/course\/\d+$/, title: '코스' },
  { pattern: /^\/learn\/lesson\/\d+$/, title: '레슨' },
  { pattern: /^\/learn\/queture\/\w+$/, title: '깨처' },
]

const BASE_TITLE = 'Quebon - 수학 교육 플랫폼'

export function usePageTitle(customTitle?: string): void {
  const location = useLocation()

  useEffect(() => {
    let pageTitle: string | undefined = customTitle

    if (!pageTitle) {
      // 정확한 경로 매칭
      pageTitle = PAGE_TITLES[location.pathname]

      // 동적 패턴 매칭
      if (!pageTitle) {
        const matched = DYNAMIC_PATTERNS.find(({ pattern }) =>
          pattern.test(location.pathname)
        )
        if (matched) pageTitle = matched.title
      }
    }

    document.title = pageTitle
      ? `${BASE_TITLE} | ${pageTitle}`
      : BASE_TITLE
  }, [location.pathname, customTitle])
}
